var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWoodModule01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 867,
    height: 719,
    viewBox: "0 0 867 719",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.14285e-05 0L0 719L867 719L867 -3.78978e-05L849 -3.7111e-05L849 5.99996L833 5.99996L833 -3.64116e-05L62 -2.71011e-06L62 6L46 6L46 -2.01072e-06L-3.14285e-05 0ZM46 482L46 494L62 494L62 482L46 482ZM46 250L46 238L62 238L62 250L46 250ZM833 494L833 482L849 482L849 494L833 494ZM833 250L833 238L849 238L849 250L833 250Z",
    fill: "#FFD100"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoodModule01);
export default __webpack_public_path__ + "static/media/wood-module_01.99dd5dfdcba8a3c5883d781daf3e0c4e.svg";
export { ForwardRef as ReactComponent };